<template>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-ZiXiShi`]" width="1em" height="1em" v-bind="$attrs"><path d="M12.0025 7.58152C13.3491 7.58152 14.4229 6.46204 14.4229 5.10326C14.4229 3.74447 13.3491 2.625 12.0025 2.625C10.6559 2.625 9.58203 3.74447 9.58203 5.10326C9.58203 6.46204 10.6559 7.58152 12.0025 7.58152Z" stroke="#333"/><path d="M15.4091 17.0171V11.6724C15.4091 11.3918 15.1122 11.2106 14.8626 11.3389L12 12.8106V17.0171M15.4091 17.0171H12M15.4091 17.0171H18.75C19.1642 17.0171 19.5 17.353 19.5 17.7671V18.3704C19.5 18.7847 19.1642 19.1204 18.75 19.1204H5.25C4.83579 19.1204 4.5 18.7847 4.5 18.3704V17.7671C4.5 17.353 4.83578 17.0171 5.25 17.0171H7.90912 12M12.001 12.8095L8.43283 11.2807C8.18541 11.1747 7.91016 11.3562 7.91016 11.6254V17.016" stroke="#333" stroke-linecap="round"/><path d="M7.90754 14.9161H6.50337C6.14 14.9161 5.83643 14.6393 5.80292 14.2775L5.77762 14.0044C5.45701 10.5428 8.18114 7.55469 11.6575 7.55469" stroke="#333" stroke-linecap="round"/><path d="M15.75 14.9161H17.1542C17.5175 14.9161 17.821 14.6393 17.8546 14.2775L17.8798 14.0044C18.2005 10.5428 15.4763 7.55469 12 7.55469" stroke="#333" stroke-linecap="square"/></svg>
</template>
<script>

export default {
  name: 'IconZiXiShi',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
